import { host } from "config/api.config"
import { useHTTPClient } from "services/httpClient.service"

const apiUrl = `${host}/filters/equipaments`
export function useGetCompanyEquipamentsApi(companyId: string){
    const {data, loading, error, get} = useHTTPClient<{id: string, name: string}[]>(`${apiUrl}/${companyId}`)
    
    async function getApi(_companyId: string){
        console.log('getting equipaments for company', _companyId || companyId)
        const result = await get({_url: `${apiUrl}/${_companyId || companyId}`})
        console.log('equipaments result', result)
        return result
    }
    return {data, loading, error, get: getApi}
}